import { createContext, useContext, type ReactNode } from "react";
import type {
  PublishedArticleCard,
  PublishedArticleDetail,
  PublishedCaseCard,
  PublishedCaseDetail,
} from "../types/content.types";

export interface PublicSiteSettings {
  articlesEnabled: boolean;
}

export interface PublicTestimonialCard {
  id: string;
  author: string;
  role: string;
  company: string;
  quote: string;
  youtubeId: string;
  avatarUrl: string;
}

export interface PublicServerData {
  route?: string;
  locale?: "pt" | "en";
  articles?: PublishedArticleCard[];
  cases?: PublishedCaseCard[];
  article?: PublishedArticleDetail;
  caseEntry?: PublishedCaseDetail;
  testimonials?: PublicTestimonialCard[];
  settings?: PublicSiteSettings;
}

interface PublicServerDataProviderProps {
  children: ReactNode;
  serverData?: PublicServerData | null;
}

const PublicServerDataContext = createContext<PublicServerData | null>(null);

export function PublicServerDataProvider({
  children,
  serverData,
}: PublicServerDataProviderProps) {
  return (
    <PublicServerDataContext.Provider value={serverData ?? null}>
      {children}
    </PublicServerDataContext.Provider>
  );
}

export function usePublicServerData() {
  return useContext(PublicServerDataContext);
}

declare global {
  interface Window {
    __AUTOU_SERVER_DATA__?: PublicServerData;
  }
}
